<div class="row steps mt-3">
    <div class="col-lg-7 col-md-12 col-sm-12" style="display: flex;
    align-items: center;">
        <div class="row pt-1 ml-1 w-100">


            <div class="col-6 col-sm p-0" [ngClass]="{'d-none d-sm-block': !steps.completeForm}">
                <div class="row p-sm-10 w-100 h-100">
                    <div class="col-4 m-0 p-0" style="display: flex;
                    align-items: center;
                    justify-content: center;">
                        <div class="number" [ngClass]="{'activeNumber': steps.completeForm}">1</div>
                    </div>
                    <div class="col-8 m-0 p-0">
                        <p class="description" style="margin: 0;" [ngClass]="{'activeDescription': steps.completeForm}">
                            Completa
                            el<br>formulario <br>de atención</p>
                    </div>
                </div>
            </div>

            <div class="col-6 col-sm p-0" [ngClass]="{'d-none d-sm-block':  steps.showSummary }">
                <div class="row p-sm-10 w-100 h-100">
                    <div class="col-4 m-0 p-0" style="display: flex;
                    align-items: center;
                    justify-content: center;">
                        <div class="number" [ngClass]="{'activeNumber': steps.payment}">2</div>
                    </div>
                    <div class="col-8 m-0 p-0" style="display: flex; align-items: center;">
                        <p class="description" style="margin: 0;" [ngClass]="{'activeDescription': steps.payment}">Elige
                            tu<br>convenio</p>
                    </div>
                </div>
            </div>

            <div class="col-6 col-sm p-0" [ngClass]="{'d-none d-sm-block': steps.completeForm }">
                <div class="row p-sm-10 w-100 h-100">
                    <div class="col-4 m-0 p-0" style="display: flex;
                    align-items: center;
                    justify-content: center;">
                        <div class="number" [ngClass]="{'activeNumber': steps.showSummary}">3</div>
                    </div>
                    <div class="col-8 m-0 p-0" style="display: flex; align-items: center;">
                        <p class="description" style="margin: 0;" [ngClass]="{'activeDescription': steps.showSummary}">
                            Confirma<br>tu reserva</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-md-12 col-sm-12">
        <div class="row">
            <div class="col-6 p-0">
                <div class="card" *ngIf="isLoading" style="min-height: 60px;">
                    <div class="loader">
                        <div class="loader__figure" style="border: 0 solid #2BABB7;"></div>
                        <p class="loader__label"></p>
                    </div>

                </div>
                <div *ngIf="!isLoading" class="card">
                    <div class="col-md-4 col-sm-12 p-0" style="display: flex;
                    gap: 2px;
                    align-items: center;
                    justify-content: center;">
                        <!-- <div class="col-md-6 col-sm-6 p-0" style="display: flex; justify-content: center;">
                            <mat-icon>schedule</mat-icon>
                          </div>
                          <div class="col-md-6 col-sm-6 p-0" style="display: flex; justify-content: center;">
                            <p class="m-0 d-flex" style="font-size: 20px;"><b>{{ redondearTiempo(tiempoEspera.data.tiempoEsperaTotal) }}</b></p>
                          </div> -->

                        <div class="col-md-6 col-sm-6 p-0 d-flex justify-content-md-end justify-content-end">
                            <mat-icon>schedule</mat-icon>
                        </div>
                        <div class="col-md-6 col-sm-6 p-0 d-flex justify-content-md-center justify-content-start">

                            <p class="m-0 d-flex" style="font-size: 20px;"><b>{{
                                    redondearTiempo(tiempoEspera.data.tiempoEspera) }}</b></p>
                        </div>

                    </div>
                    <div class="col-md-8 col-sm-12 d-flex p-0"
                        style="justify-content: center;    padding: 0 10px !important;">
                        <span><b>Minutos</b> de espera</span>
                    </div>
                </div>
            </div>
            <div class="col-6 p-0">
                <div class="card" *ngIf="isLoading" style="min-height: 60px;">
                    <div class="loader">
                        <div class="loader__figure" style="border: 0 solid #2BABB7;"></div>
                        <p class="loader__label"></p>
                    </div>

                </div>
                <div *ngIf="!isLoading" class="card">
                    <div class="col-md-4 col-sm-12 p-0" style="display: flex;
                    gap: 2px;
                    align-items: center;
                    justify-content: center;">
                        <div class="col-md-6 col-sm-6 p-0 d-flex justify-content-md-end justify-content-end">
                            <mat-icon>person_outline</mat-icon>
                        </div>
                        <div class="col-md-6 col-sm-6 p-0 d-flex justify-content-md-center justify-content-start">
                           
                            <p class="m-0 d-flex" style="font-size: 20px;"><b>{{tiempoEspera.data.totalPacientes}}</b>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-12 d-flex p-0"
                        style="justify-content: center;    padding: 0 10px !important;">
                        <span><b>Personas</b> en la fila</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>